import React from "react";
import { CompletionLogDto, maintenanceTasksApi } from "../../../services/api";
import { formatDate } from "../utils";

interface Props {
  taskId: string;
  refreshKey?: number;
}

export const TaskHistoryList: React.FC<Props> = ({ taskId, refreshKey }) => {
  const [logs, setLogs] = React.useState<CompletionLogDto[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    maintenanceTasksApi.history(taskId, 50)
      .then((data) => { if (!cancelled) setLogs(data); })
      .catch(() => { if (!cancelled) setLogs([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [taskId, refreshKey]);

  if (loading) return <div className="text-sm text-slate-500">Cargando historial…</div>;
  if (logs.length === 0) return <div className="text-sm text-slate-500">Aún no se ha completado nunca.</div>;

  return (
    <ul className="space-y-2">
      {logs.map((l) => (
        <li key={l.id} className="border rounded p-3 bg-white text-sm">
          <div className="flex justify-between items-start">
            <div>
              <div className="font-medium">{formatDate(l.completedAt, false)}</div>
              <div className="text-xs text-slate-500">
                Registrado {formatDate(l.registeredAt)}
                {l.completedByUserName && <> · por {l.completedByUserName}</>}
              </div>
            </div>
            {l.costAmount != null && (
              <div className="text-sm font-medium text-slate-700">{l.costAmount.toFixed(2)} €</div>
            )}
          </div>
          {l.notes && <p className="mt-2 text-slate-700 whitespace-pre-wrap">{l.notes}</p>}
          {l.nextDueAtSnapshot && (
            <div className="text-xs text-slate-500 mt-1">
              Próxima revisión calculada: {formatDate(l.nextDueAtSnapshot, false)}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};
